export type {AvatarTextProps} from './types';
export {getAvatarDisplayText} from './utils';
export {AvatarText} from './AvatarText';
